<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="goods-detail-dialog" top="5vh" width="1100px" :fullscreen="isExpand" :show-close="false" :before-close="handleClose">
    <template slot="title">
      <div class="default-dialog-title-box">
        <span>查看商品</span>
        <span class="icon-box">
          <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
          <i class="el-icon-close" @click="handleClose"></i>
        </span>
      </div>
    </template>
    <div class="content">
      <el-descriptions :colon="false" :column="3" size="medium" labelClassName="descriptionsLabel" contentClassName="descriptionsValue">
        <el-descriptions-item label="商品编码sku">{{ detail.sn || '--' }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">
          <div class="content-goods-name">
            <span>{{ detail.goodsName || '--' }}</span>
            <!-- 审核状态 -->
            <template v-if="from === 'platform'">
              <span :class="['c_tag', getColor(detail.authFlag)]">
                {{ detail.authFlag === 'TOBEAUDITED' ? '平台审核中' : detail.authFlag === 'PASS' ? '审核通过' : detail.authFlag === 'REFUSE' ? '审核驳回' : '' }}
              </span>
              <el-tooltip
                v-if="detail.authFlag === 'REFUSE'"
                effect="dark"
                :content="`驳回原因：${detail.authMessage}`"
                placement="bottom"
              >
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </template>
            <!-- 上架状态 -->
            <span v-if="detail.authFlag" :class="['c_tag', detail.authFlag === 'PASS' ? getColor(detail.marketEnable) : '']">
              {{ detail.authFlag === 'PASS' ? (detail.marketEnable === 'UPPER' ? '已上架' : detail.marketEnable === 'DOWN' ? '已下架' : '--') : '' }}
            </span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="商品别名">{{ detail.anotherName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="型号">{{ detail.model || '--' }}</el-descriptions-item>
        <el-descriptions-item label="规格">{{ detail.simpleSpecs || '--' }}</el-descriptions-item>
        <el-descriptions-item label="计量单位">{{ detail.goodsUnit || '--' }}</el-descriptions-item>
        <el-descriptions-item :label="detail.saleType === 'SUBSCRIPTION_SALE' ? '平台商品分类' : '商品分类'">{{ detail.categoryName || '--' }}</el-descriptions-item>
        <el-descriptions-item v-if="detail.saleType === 'SUBSCRIPTION_SALE'" label="商品分类">{{ detail.merchantGoodsCategoryName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="商品品牌">{{ detail.brandName || '--' }}</el-descriptions-item>
        <el-descriptions-item label="原厂备件号">{{ detail.storeSn || '--' }}</el-descriptions-item>
        <el-descriptions-item label="医疗件属性">{{ detail.medicalFlag ? '医疗件' : '非医疗件' }}</el-descriptions-item>
        <el-descriptions-item label="注册证号/备案凭证号">{{ detail.registerCode || '--' }}</el-descriptions-item>
        <el-descriptions-item label="质保期/保修期">{{ `${detail.qualityAssPeriod || ''}${ detail.qualityAssPeriod && detail.qualityAssPeriodUnitName ? detail.qualityAssPeriodUnitName : ''}` || '--' }}</el-descriptions-item>
        <el-descriptions-item label="商品描述" :span="3">{{ detail.sellingPoint || '--' }}</el-descriptions-item>
        <el-descriptions-item v-if="detail.rootCategoryCode === 'PART'" label="适配设备">
          <template v-if="detail.deviceType === '1' && detail.deviceList && detail.deviceList.length">
            <el-tooltip class="item" effect="dark" :content="detail.deviceNames" placement="bottom">
              <div style="width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ detail.deviceNames || '--' }}</div>
            </el-tooltip>
          </template>
          <template v-else-if="detail.deviceType === '2'">通用</template>
          <template v-else>--</template>
        </el-descriptions-item>
        <el-descriptions-item v-if="detail.rootCategoryCode === 'PART'" label="适配品牌">
          <el-tooltip class="item" effect="dark" :content="detail.adaptedBrandType === 2 ? '通用' : detail.deviceBrandNames" placement="bottom">
            <div style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ detail.adaptedBrandType === 2 ? '通用' : detail.deviceBrandNames || '--' }}</div>
          </el-tooltip>
        </el-descriptions-item>
        <el-descriptions-item v-if="detail.rootCategoryCode === 'PART'" label="适配设备分类">
          <el-tooltip class="item" effect="dark" :content="detail.adaptedCategoryType === 2 ? '通用' : detail.deviceCategoryNames" placement="bottom">
            <div style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ detail.adaptedCategoryType === 2 ? '通用' : detail.deviceCategoryNames || '--' }}</div>
          </el-tooltip>
        </el-descriptions-item>
        <el-descriptions-item label="商品图片" :span="3">
          <template>
            <div v-if="detail.imageList && detail.imageList.length">
              <el-image
                v-for="(img, i) in detail.imageList"
                :key="'licence-'+i"
                :src="img.url"
                :preview-src-list="detail.imageList.map(img => img.url)"
                style="width: 88px; height: 88px; margin-right: 10px; margin-bottom: 10px;">
              </el-image>
            </div>
            <div v-else>--</div>
          </template>
        </el-descriptions-item>
        <el-descriptions-item label="商品数量">{{ `${detail.quantity !== null ? detail.quantity : ''}${detail.goodsUnit || ''}` }}</el-descriptions-item>
        <el-descriptions-item label="销售单价">{{ detail.price !== null && detail.price !== undefined ? `${detail.price}元` : '' || '面议' }}</el-descriptions-item>
      </el-descriptions>

      <xz-table ref="xzTable" :columns="serialListColumns" :data="detail.serialList" rowKey="id"></xz-table>

      <div style="padding: 10px 20px;">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="日志" name="logs"></el-tab-pane>
          <el-tab-pane v-if="detail.medicalFlag" label="产品注册证" name="register"></el-tab-pane>
        </el-tabs>

        <xz-table v-if="activeName === 'logs'" ref="xzTable" :columns="logColumns" :data="logData" rowKey="id"></xz-table>

        <el-descriptions v-if="detail.medicalFlag && activeName === 'register'" :colon="false" :column="3" size="medium" labelClassName="descriptionsLabel" contentClassName="descriptionsValue">
          <el-descriptions-item label="医疗器械分类">{{ registerInfo.medicalPathName || '--' }}</el-descriptions-item>
          <el-descriptions-item label="注册人/备案人/代理人">{{ registerInfo.registrantName || '--' }}</el-descriptions-item>
          <el-descriptions-item label="注册证号/备案凭证号">{{ registerInfo.registrationCode || '--' }}</el-descriptions-item>
          <el-descriptions-item label="批准备案日期">{{ registerInfo.approvalDate ? formatDate(registerInfo.approvalDate) : '--' }}</el-descriptions-item>
          <el-descriptions-item label="有效期至">{{ registerInfo.effectiveDate ? formatDate(registerInfo.effectiveDate) : '--' }}</el-descriptions-item>
          <el-descriptions-item label="管理类别">{{ getCategoryLabel(registerInfo.category) }}</el-descriptions-item>
          <el-descriptions-item label="厂商名称">{{ registerInfo.manufacturerName || '--' }}</el-descriptions-item>
          <el-descriptions-item label="厂商地区" :span="2">{{ `${registerInfo.originProvinceName || ''}${registerInfo.originCityName || ''}${registerInfo.originAreaName || ''}` || '--' }}</el-descriptions-item>
          <el-descriptions-item label="产品注册证/备案凭证图片" :span="3">
            <div v-if="registerInfo.annexList && registerInfo.annexList.length">
              <el-image
                v-for="(annex, i) in registerInfo.annexList"
                :key="'licence-'+i"
                :src="annex.url"
                :preview-src-list="registerInfo.annexList.map(annex => annex.url)"
                style="width: 88px; height: 88px; margin-right: 10px; margin-bottom: 10px;">
              </el-image>
            </div>
            <template v-else>--</template>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import * as Moment from 'dayjs';
import { operationLog } from '@/api/goods';
import { goodsSkuDetail } from '@/api/shop';
import { registerProductDetail } from '@/api/registerNo';
import { categoryList } from '@/enums/managerCategoryEnum';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
export default {
  components: {
    xzTable,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    storeId: {
      type: String,
      default: '',
    },
    from: {
      type: String,
      default: '',
    },
  },
  watch: {
    dialogVisible (v) {
      if (v && this.id) {
        this.activeName = 'logs';
        this.queryGoodsDetail();
        this.queryOperationLogs();
      }
    },
  },
  data () {
    return {
      isExpand: false,
      dialogVisible: false,
      expandSvg: require('@/assets/ic_expand.svg'),
      collapseSvg: require('@/assets/ic_collapse.svg'),
      activeName: 'logs',
      detail: {},
      registerInfo: {},
      logData: [],
      logColumns: [
        {
          title: '日志类型',
          dataIndex: 'sourceDesc',
          key: 'sourceDesc',
          width: 120,
        },
        {
          title: '事件类型',
          dataIndex: 'eventTypeDesc',
          key: 'eventTypeDesc',
          width: 120,
        },
        {
          title: '创建人',
          dataIndex: 'createUserName',
          key: 'createUserName',
          width: 120,
        },
        {
          title: '发生时间',
          dataIndex: 'lastUpdateTime',
          key: 'lastUpdateTime',
          width: 180,
          customRender: (text) => {
            return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
          },
        },
        {
          title: '日志内容',
          dataIndex: 'content',
          key: 'content',
        },
      ],
      serialListColumns: [
        {
          title: '仓库名称',
          dataIndex: 'warehouseName',
          key: 'warehouseName',
        },
        {
          title: '序列号',
          dataIndex: 'serialNo',
          key: 'serialNo',
        },
        {
          title: '货位号',
          dataIndex: 'storageLocation',
          key: 'storageLocation',
        },
        {
          title: '批次号',
          dataIndex: 'batchNo',
          key: 'batchNo',
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          key: 'quantity',
        },
      ],
    };
  },
  methods: {
    getColor (v) {
      const green = ['PASS', 'UPPER'];
      const orange = ['TOBEAUDITED'];
      const red = ['REFUSE'];
      const grey = ['DOWN', 'NOT'];
      // const bule = ['TOBEAUDITED'];
      if (green.includes(v)) return 'green';
      if (orange.includes(v)) return 'orange';
      if (red.includes(v)) return 'red';
      if (grey.includes(v)) return 'grey';
      // if (bule.includes(v)) return 'bule';
      return '';
    },
    formatDate (text, format = 'YYYY-MM-DD') {
      const day = text ? Moment(text * 1).format(format) : '/';
      return day === '9999-12-31' ? '永久' : day;
    },
    getCategoryLabel (v) {
      return categoryList.find(item => item.value === v)?.label || '--';
    },
    handleClose () {
      this.dialogVisible = false;
    },
    handleClick () {
      if (this.activeName === 'logs') {
        this.queryOperationLogs();
      }
      if (this.activeName === 'register') {
        this.queryRegisterDetail();
      }
    },
    async queryOperationLogs () {
      if (!this.id) return;
      const { body } = await operationLog({
        businessId: this.id,
        module: 'GOODS',
        businessType: 'GOODS_SKU',
        pageFlag: false,
        orderBy: [
          {
            orderByProperty: 'lastUpdateTime',
            orderByType: 'DESC',
          },
        ],
      });
      this.logData = body?.list || [];
    },
    async queryRegisterDetail () {
      const { body } = await registerProductDetail({ registrationCode: this.detail.registerCode });
      this.registerInfo = body || {};
    },
    async queryGoodsDetail () {
      let { body } = await goodsSkuDetail({
        id: this.id,
        storeId: this.storeId,
        findDeviceFlag: true,
        findGoodsSkuSerialFlag: true,
        findAdaptedBrandFlag: true,
        findAdaptedCategoryFlag: true,
      });
      body.deviceNames = (body?.deviceList || []).map(item => `${item.deviceName}_${item.deviceBrandName}_${item.deviceModel}`).join('；');
      body.deviceBrandNames = (body?.adaptedBrandList || []).map(item => item.brandName).filter(item => item).join('；');
      body.deviceCategoryNames = (body?.adaptedCategoryList || []).map(item => item.categoryName).filter(item => item).join('；');
      body.serialList = body?.serialList || [];
      this.detail = body || {};
    },
  },
};
</script>
<style lang="scss" scoped>
.goods-detail-dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }
  .content-goods-name {
    flex-direction: row;
    .c_tag {
      padding: 2px 4px;
      border-radius: 4px;
      margin: 0 3px;
    }

    .orange {
      background-color: #fefae0;
      color: #fab007;
    }
    .red{
      background: #FEE9E5;
      color: #FF5959;
    }

    .green {
      background: #E5FEEB;
      color: #14CA64;
    }

    .grey {
      background-color: #F2F4F7;
      color: #1F2733;
    }
    .bule {
      background: #e2f3fe;
      color: #237ffa;
    }
  }
}
/deep/ .descriptionsLabel {
  width: 100px;
  text-align: right;
  display: inline-block;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #929aa6;
  letter-spacing: 0;
  text-align: right;
  line-height: 20px;
}
/deep/ .descriptionsValue {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1f2733;
  letter-spacing: 0;
  text-align: left;
  line-height: 20px;
  display: flex;
  flex-direction: column;
}
</style>
